import { useMemo } from 'react';
import {
  toEntityIds,
  useBusinessEntityMaps
} from '../../common/services/useBusinessEntityMaps';

// Structural rather than IShipment-specific so IShipmentGridRow (MyWorkItems Details rows) can
// reuse the same entity lookup as the main Shipments grid.
export interface IShipmentEntityRow {
  destinationId: string;
  pickupCarrierId: string | null;
}

export function useShipmentEntities(rows: IShipmentEntityRow[]) {
  const destinationIds = useMemo(
    () => toEntityIds(rows.map(row => row.destinationId)),
    [rows]
  );
  const carrierIds = useMemo(
    () => toEntityIds(rows.map(row => row.pickupCarrierId)),
    [rows]
  );

  const { locationsMap, carriersMap, isLoading } = useBusinessEntityMaps(
    destinationIds,
    carrierIds
  );

  return { destinationsMap: locationsMap, carriersMap, isLoading };
}

export default useShipmentEntities;
